import {ReactNode, useContext} from "react";
import {TokenContext} from "../context/TokenContext";
import {Navigate} from 'react-router-dom';
import {AppPermissions} from "../model/Group";

interface AccessControlProps {
    roles: AppPermissions[]
    children: ReactNode
}

function AccessControl({children, roles}: AccessControlProps) {
    const {roles: userRoles} = useContext(TokenContext);

    if (userRoles.length === 0) {
        return <></>
    }

    const hasAccess = roles.some(routePermission => userRoles.includes(routePermission))

    if (!hasAccess) {
        return <Navigate to="/" replace />
    }

    return <>
        {children}
    </>
}

export default AccessControl